import { render, staticRenderFns } from "./GesRenIndividual.vue?vue&type=template&id=85a6b372&scoped=true&"
import script from "./GesRenIndividual.vue?vue&type=script&lang=js&"
export * from "./GesRenIndividual.vue?vue&type=script&lang=js&"
import style0 from "./GesRenIndividual.vue?vue&type=style&index=0&id=85a6b372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a6b372",
  null
  
)

export default component.exports